
import TableList from "@components/templates/tablelist";
import { HttpGetTrackingChange, HttpChangeStatus, } from "@/service/expresspackage";
import exportModal from './exportModal'
import { mapState, mapGetters } from "vuex";
import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                },
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            exportData: {},
        };
    },
    methods: {
        ajaxRequest: HttpGetTrackingChange,
        interceptRequest(params){
            this.exportData = params
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'delivertRecallUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'delivertRecallUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeids: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "delivertRecallUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "submitbox":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.update_submit', { defaultValue: "提交" }),
                        width: 460,
                        params: { id: params, status:1 },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false,
                            }
                        ],
                        ajaxRequest: HttpChangeStatus
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 460,
                        params: { id: params, status:6 },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false,
                            }
                        ],
                        ajaxRequest: HttpChangeStatus,
                    };
                    break;
                case "export":
                    // this.handleWebfs(
                    //     process.env.VUE_APP_APIURL_BOSS + "/api/v2/TrackingChange/export", {search: this.exportData.search},
                    //     {
                    //         executor: "request",
                    //         download: true,
                    //         method: 'get'
                    //     }
                    // );
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +'/api/v2/TrackingChange/export',{search: this.exportData.search}, 'download')
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: "导入",
                        width: 550,
                        component: exportModal,
                        showFooter: false,
                        showDesc: false,
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, orderStatus } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: this.handleAuth('tracking.change.index'),
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.update_submit', { defaultValue: "提交" }),
                    show: orderStatus === 0 && this.handleAuth('tracking.change.index'),
                    params: id,
                    operate: 'submitbox'
                },
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: orderStatus === 0 && this.handleAuth('tracking.change.index'),
                    params: id,
                    operate: 'edit'
                },
                {
                    label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                    show: (orderStatus === 0 || orderStatus === 1) && this.handleAuth('tracking.change.index'),
                    params: id,
                    operate: 'cancel'
                }
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getSystemPortList', 'getCompanyList', 'getUserManageWarehouseList','getNextOrgList']),
        ...mapGetters("common", ["getStateList"]),
        getStatus(){
            return [
                {label:this.$t('fbb.headlogistics.draft', { defaultValue: '草稿' }),value:'0'},
                {label:this.$t('fbb.expresspackage.pending_acceptance', { defaultValue: "待受理" }),value:'1'},
                {label:this.$t('fbb.expresspackage.under_acceptance', { defaultValue: "受理中" }),value:'2'},
                {label:this.$t('fbb.expresspackage.accepted', { defaultValue: "已受理" }),value:'3'},
                {label:this.$t('fbb.expresspackage.accepted_successfully', { defaultValue: "受理成功" }),value:'4'},
                {label:this.$t('fbb.expresspackage.acceptance_failed', { defaultValue: "受理失败" }),value:'5'},
                {label:this.$t('erp.b2c.orderstatus_canceled', { defaultValue: '已取消' }),value:'6'},
            ]
        },
        getLogisticsStatus(){
            return [
                {value:'0',label:'UNKNOWN'},
                {value:'1',label:'PRE TRANSIT'},
                {value:'2',label:'IN TRANSIT'},
                {value:'3',label:'OUT FOR DELIVERY'},
                {value:'4',label:'DELIVERED'},
                {value:'5',label:'AVAILABLE FOR PICKUP'},
                {value:'6',label:'RETURN TO SENDER'},
                {value:'7',label:'FAILURE'},
                {value:'8',label:'CANCELLED'},
                {value:'9',label:'ERROR'},
                {value:'11',label:"Label Created"},
            ]
        },
        TabsData() {
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: '全部' }),
                    key: 'EQ_orderStatus',
                    val: null
                },
                {
                    name: this.$t('fbb.headlogistics.draft', { defaultValue: '草稿' }),
                    key: 'EQ_orderStatus',
                    val: '0',
                },
                {
                    name: this.$t('fbb.expresspackage.pending_acceptance', { defaultValue: "待受理" }),
                    key: 'EQ_orderStatus',
                    val: '1'
                },
                {
                    name: this.$t('fbb.expresspackage.under_acceptance', { defaultValue: "受理中" }),
                    key: 'EQ_orderStatus',
                    val: '2'
                },
                {
                    name: this.$t('fbb.expresspackage.accepted', { defaultValue: "已受理" }),
                    key: 'EQ_orderStatus',
                    val: '3'
                },
                {
                    name: this.$t('fbb.expresspackage.accepted_successfully', { defaultValue: "受理成功" }),
                    key: 'EQ_orderStatus',
                    val: '4'
                },
                {
                    name: this.$t('fbb.expresspackage.acceptance_failed', { defaultValue: "受理失败" }),
                    key: 'EQ_orderStatus',
                    val: '5'
                },
                {
                    name: this.$t('erp.b2c.orderstatus_canceled', { defaultValue: "已取消" }),
                    key: 'EQ_orderStatus',
                    val: '6'
                },
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                },
                {
                    label: this.$t('global.common.import', { defaultValue: '导入' }),
                    operate: "import",
                    show: this.handleAuth("tracking.change.index"),
                    theme: "info",
                },
                {
                    label: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "export",
                    show: this.handleAuth("tracking.change.index")
                },
                
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.expresspackage.sale_order_no',{defaultValue:'来源单号'}),
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    show: true,
                },
                {
                    label: this.$t('fbb.inbound.logistics_singleno',{defaultValue:'物流单号'}),
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                    show: true,
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    tag: 'vSelect',
                    key: 'IN_orderStatus',
                    options: this.getStatus,
                    props: {
                        filterable: true,
                    },
                    show: true,
                },
                {
                    label:this.$t('global.common.operate_type', { defaultValue: "类型" }),
                    tag:'vSelect',
                    key:'IN_handleType',
                    options:[
                        {value:1,label:'召回'},
                        {value:2,label:'更址'},
                        {value:3,label:'在途异常'},
                    ]
                },
                {
                    label: this.$t('boss.purchase.update_time',{defaultValue:'更新时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id',
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                },
                {
                    title: this.$t('fbb.expresspackage.change_order_number', { defaultValue: '异动单号' })+'/'+this.$t('fbb.expresspackage.sale_order_no',{defaultValue:'来源单号'}),
                    sortable: true,
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.trackingChangeOrderNo || '--'}</a>
                                <div>{row.sourceNo||'--'}</div>
                            </div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.inbound.logistics_singleno',{defaultValue:'物流单号'}),
                    render: (h, { row }) => {
                        return <div>{row.trackingNo}</div>
                    },
                },
                {
                    title: this.$t('fbb.alloment.order_status',{defaultValue:'单据状态'}),
                    key: 'orderStatus',
                    // render: (h, { row }) => this.findRenderLabel(this.getStatus, row.orderStatus)
                    render: (h, { row }) => {
                        switch (row.orderStatus) {
                            case 0: return <Button class="b2cspan-error span-padding">{this.$t('fbb.headlogistics.draft',{defaultValue:'草稿'})}</Button>;
                            case 1: return <Button class="b2cspan-middle-content span-padding">{this.$t('fbb.expresspackage.pending_acceptance',{defaultValue:'待受理'})}</Button>;
                            case 2: return <Button class="b2cspan-success span-padding">{this.$t('fbb.expresspackage.under_acceptance',{defaultValue:'受理中'})}</Button>;
                            case 3: return <Button class="b2cspan-primary span-padding">{this.$t('fbb.expresspackage.accepted',{defaultValue:'已受理'})}</Button>;
                            case 4: return <Button class="b2cspan-info span-padding">{this.$t('fbb.expresspackage.accepted_successfully',{defaultValue:'受理成功'})}</Button>;
                            case 5: return <Button class="b2cspan-light-content span-padding">{this.$t('fbb.expresspackage.acceptance_failed',{defaultValue:'受理失败'})}</Button>;
                            case 6: return <Button class="b2cspan-warning span-padding">{this.$t('erp.b2c.orderstatus_canceled',{defaultValue:'已取消'})}</Button>;
                        }
                    },
                },
                {
                    title: this.$t('global.common.operate_type', { defaultValue: "类型" }),
                    render: (h, { row }) => {
                        return <div>
                            {row.handleType === 1 ? this.$t('fbb.expresspackage.recall',{defaultValue:'召回'}) : row.handleType === 2 ? this.$t('fbb.expresspackage.change_address',{defaultValue:'更址'}) : row.handleType === 3 ? this.$t('fbb.expresspackage.abnormal_in_transit',{defaultValue:'在途异常'}) : '--'}
                        </div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: "异动标记" }),
                    key:'trackingLabel',
                    render:(h,{row})=>{
                        return <div>
                            {row.trackingLabel===1?this.$t('fbb.expresspackage.under_recall', { defaultValue: "召回中" }):'--'}
                        </div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: "物流状态" }),
                    render: (h, { row }) => {
                        let font=this.findRenderLabel(this.getLogisticsStatus, row.logisticsStatus);
                        if(row.trackingNo){
                            let trackNo=row.trackingNo;
                            let url='';
                            if (trackNo.slice(0,2) === '1Z') {
                                url = `https://www.ups.com/track?loc=zh_CN&tracknum=${trackNo}&requester=WT/tracksummary`
                            }
                            else {
                                url = `https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=${trackNo}&locale=en_US&cntry_code=ratetools`
                            }
                            return <a target="_blank" href={url}>{font}</a>
                        }
                    }
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    width: 180,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.updatedAt || '--'}</div>
                        </div>
                    }
                },
            ];
        },

    },

};
